import {
  // CITY_KIEV,
  DHL_DELIVERY_SERVICE,
  NOVAPOSHTA_GLOBAL_DELIVERY_SERVICE,
  FEDEX_DELIVERY_SERVICE,
  TNT_DELIVERY_SERVICE,
  DHLPL_DELIVERY_SERVICE,
  NOVAPOSHTA_INTERNATIONAL_DELIVERY_SERVICE
} from "../../../../staticData/staticVariables";
import {Express} from "./Express";

Express.prototype.vatNumberValidation = function (isValidateVatFile = false) {


  if(!this.getVisibleVatNumber() || isValidateVatFile) return true
  console.log(isValidateVatFile);
  console.log(2222);
  let validationItems = {
    vatNumber: this.getVatNumber(),
  }

  let validationOptions = {
    vatNumber: {type: ['empty']},
  }

  return this.checkValid(validationItems, validationOptions)
}

Express.prototype.insuranceValueValidate = function () {

  let sum = 0
  this.express.products.map(item => {
    sum += parseFloat(item.getProductPrice()) * parseInt(item.getProductItemsQuantity())
  })

  return this.express.packaging.insuranceValueValidate(sum)

}

Express.prototype.validateOrderPrice = function () {

  if(this.express.type === DHL_DELIVERY_SERVICE.id && this.express.orderPrice !== ''){
    let totalSum = this.getTotalSumProduct()
    if((parseFloat(this.express.orderPrice)) <= parseFloat(totalSum)){
      this.validation.orderPrice = false
      this.validationTranslate.orderPrice = ''
    } else {
      this.validation.orderPrice = true
      this.validationTranslate.orderPrice = 'express_orderPriceValidate'
      return false
    }
  }

  return true

}

Express.prototype.validateAdditionFiles = function () {
  let valid = true

  if(this.express.type !== FEDEX_DELIVERY_SERVICE.id) {
    return valid
  }

  // if(this.express.additionFiles.data.maxCountFiles -
  //   (this.express.additionFiles.data.files.length + this.express.additionFiles.data.downloadFiles.length) > 0){
  //   this.express.additionFiles.validation.files = true
  //   valid = false
  // } else {
  //   this.express.additionFiles.validation.files = false
  // }

  if(this.express.additionFiles.data.files.length > 0 && !this.express.additionFiles.firstValidation()) {
    valid = false
  }

  return valid
}

Express.prototype.validateProducts = function () {
  if(this.express.products.length > 0) {
    this.validation.products = false
    this.validationTranslate.products = ''
  }
  else {
    this.validation.products = true
    this.validationTranslate.products = 'error_required'
    return false
  }

  return true

}

Express.prototype.validateGccCpcCertificate = function (isGccCpcCertificate) {
  let valid = true

  if(!isGccCpcCertificate) return valid

  if(this.express.gccCpcCertificate &&
    this.express.gccCpcCertificateFiles.data.maxCountFiles -
    (this.express.gccCpcCertificateFiles.data.files.length + this.express.gccCpcCertificateFiles.data.downloadFiles.length) > 0){
    this.express.gccCpcCertificateFiles.validation.files = true
    valid = false
  } else {
    this.express.gccCpcCertificateFiles.validation.files = false
  }

  // if(this.express.gccCpcCertificate && !this.express.gccCpcCertificateFiles.data.files.length &&
  //   !Object.keys(this.express.gccCpcCertificateFiles.data.downloadFiles).length) {
  //   valid = false
  // }

  if(this.express.gccCpcCertificateFiles.data.files.length > 0 && !this.express.gccCpcCertificateFiles.firstValidation()) {
    valid = false
  }

  return valid
}

Express.prototype.validateProductsDescription = function () {
  let validationItems = {
    productsDescription: this.express.productsDescription,
  }

  let validationOptions = {
    productsDescription: {type: ['empty']}
  }

  return this.checkValid(validationItems, validationOptions)
}

Express.prototype.firstValidationUser = function () {

  let validationItems = {
    user: this.express.userId,
  }

  let validationOptions = {
    user: {type: ['empty']}
  }

  return this.checkValid(validationItems, validationOptions)
}

Express.prototype.firstValid = function (that) {

  let validationItems = {}
  let validationOptions = {}

  if (this.express.sendType === this.express.sendTypes.warehouse) {
    validationItems = {
      warehouse: this.express.warehouse,
      trackingNumber: this.express.trackingNumber,
    }
    validationOptions = {
      warehouse: {type: ['empty']},
      trackingNumber: {type: ['latin']},
    }
  } else {
    validationItems = {
      senderContactName: this.express.senderContactName,
      senderPhone: this.express.senderPhone,
    }
    validationOptions = {
      senderContactName: {type: ['latin', 'empty']},
      // senderPhone: {type: ['phone', 'empty']},
      senderPhone: {type: ['empty']},
    }
  }

  let valid = true
  if(
    (this.express.type === NOVAPOSHTA_GLOBAL_DELIVERY_SERVICE.id || this.express.type === NOVAPOSHTA_INTERNATIONAL_DELIVERY_SERVICE.id)
    && this.express.serviceType === this.express.serviceTypes.department && !this.express.novaPoshtaAddress) {
    this.validation.novaPoshtaAddress = true
    this.validationTranslate.novaPoshtaAddress = 'error_required'
    valid = false
  } else {
    this.validation.novaPoshtaAddress = false
    this.validationTranslate.novaPoshtaAddress = ''
  }

  if(this.express.customerType === this.express.customerTypes.company &&
    (!that.getUserCompany ||
    !that.getUserCompany.fedex_company_name ||
    !that.getUserCompany.fedex_company_nip_vat ||
    !that.getUserCompany.fedex_company_address ||
    !that.getUserCompany.country ||
    !that.getUserCompany.fedex_company_city ||
    !that.getUserCompany.fedex_company_zip)
  ) {
    valid = false
    this.validationTranslate.companyData = 'error_companyData'
  } else {
    this.validationTranslate.companyData = ''
  }

  return (this.checkValid(validationItems, validationOptions) || this.express.type === DHLPL_DELIVERY_SERVICE.id) && valid
}

Express.prototype.deliveryDateValid = function (isValidateVatFile = false) {

  let valid = true

  let ex = this.express,
    validationItems = {
      deliveryDate: ex.deliveryDate,
    },
    validationOptions = {
      deliveryDate: {type: ['empty']},
    }

  if(ex.type === TNT_DELIVERY_SERVICE.id && ex.sendType === ex.sendTypes.sender){
    validationItems.timeCourierTo = ex.timeCourierTo
    validationItems.timeCourierFrom = ex.timeCourierFrom

    validationOptions.timeCourierTo = {type: ['empty']}
    validationOptions.timeCourierFrom = {type: ['empty']}

    if(ex.lunchBreak){
      validationItems.timeNotAvailableTo = ex.timeNotAvailableTo
      validationItems.timeNotAvailableFrom = ex.timeNotAvailableFrom

      validationOptions.timeNotAvailableTo = {type: ['empty']}
      validationOptions.timeNotAvailableFrom = {type: ['empty']}
    }
  }

  // ex.type === FEDEX_DELIVERY_SERVICE.id && ex.warehouse?.id === CITY_KIEV.id &&
  if(ex.visibleVatNumber && !isValidateVatFile) {
    valid = ex.vatNumberFile.firstValidation()
    console.log(isValidateVatFile);
    console.log(2222);
  }

  if(ex.recipientNeedTax) {
    validationItems.recipientTax = ex.recipientTax
    validationOptions['recipientTax'] = {type: ['empty']}
  }

  return this.checkValid(validationItems, validationOptions) && valid
}

Express.prototype.freightCostValidate = function () {
  if (!this.express.visibleFreightCost) return true

  let validationItems = {
    freightCost: this.express.freightCost,
  }

  let validationOptions = {
    freightCost: {type: ['numeric', 'empty']}
  }

  return this.checkValid(validationItems, validationOptions)
}

Express.prototype.deliveryFilesValid = function () {

  if(this.express.filesMaxSizeError) return false

  let ex = this.express,
    files =
      (Object.keys(ex.files).length > 0 ||
        Object.keys(ex.downloadFiles).length > 0) ? 1 : '',

    validationItems = {
      files: files,
    },
    validationOptions = {
      files: {type: ['empty']},
    }

  return this.checkValid(validationItems, validationOptions)
}


Express.prototype.DDPValidate = function (isNPI) {

  if(isNPI) return true

  let validationItems = {
    freightCost: this.express.checkDDP,
  }

  let validationOptions = {
    freightCost: {type: ['empty']}
  }

  return this.checkValid(validationItems, validationOptions)
}
